import { Navigate, Routes, Route, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { ReportList } from './ReportList'
import PermissionsService from '../auth/PermissionsService'
const ReportPageEventJourney = () => {
  const intl = useIntl()
  const userBreadCrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: '',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const permissions = PermissionsService.getPermissions();
  const {
    hasConsumptionReportJourneyServicePermission,

  } = permissions || {};



  return (
    <Routes>
      <Route element={<Outlet />}>

        {hasConsumptionReportJourneyServicePermission ? ( 
          <Route
            path='list'
            element={
              <>
                <ReportList />
                <PageTitle breadcrumbs={userBreadCrumbs}>
                Reporte de eventos generados
                </PageTitle>
              </>
            }
          />

       ) : (
          <Route path='list' element={<Navigate to='/error/403' replace />} />
        )} 

      </Route>
      <Route index element={<Navigate to='list' />} />
    </Routes>
  )
}

export default ReportPageEventJourney
